import { render, staticRenderFns } from "./customeAdd.vue?vue&type=template&id=23c9f2c1&"
import script from "./customeAdd.vue?vue&type=script&lang=js&"
export * from "./customeAdd.vue?vue&type=script&lang=js&"
import style0 from "./customeAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports